/*
 * @Descripttion: 人群选择
 * @Author: yang chenglin
 */

import { lazy } from 'ice';
import UUID from '@/utils/UUID';
import LzMsg from '@/components/common/LzMsg';
import iconImage from '@/assets/images/CanvasImages/select-crowd.svg';
import Form from './Form';
import Info from './Info';

export default {
  info: {
    icon: 'icon-iconlujingyunsuan_huaban1',
    // iconText: '&#xe675;',
    iconText: iconImage,
    name: 'CROWD_DIG',
    label: '人群选择',
    //输入类型： 0-无 1-人群包 2-人群包列表
    inputType: 0, //无输入
    minInputCount: 0, //最小输入数量0
    maxInputCount: 0, //最大输入数量0
    //输出类型： 0-可选 1-人群包 2-人群包列表
    outputType: 1, //输出人群包
    minOutputCount: 1, //最小输出数量1
    maxOutputCount: 99, //最大输出数量99
    desc: '从人群策略或人群包列表选择已创建好的人群'
  },
  data: () => ({
    name: `人群策略 ${UUID.getNowTime()}`,
    executionTime: '', // 执行时间
    executionMinute: '0', // 循环执行类型，执行时间有分钟限制
    crowdId: '', // 人群包id
    crowdName: '', // 人群包名
    crowdNum: 0, // 人群包人数
    crowdType: '', //二选一，策略或包id: strategy | instance
    crowdKeyId: '', // 所选的人群的序号id
    description: '', // 所选的人群描述
    peopleName: '', // 所选的人群名 【上面三个，是为了后续人群分析节点存个值】
    remark: '',
    cycleType: null, //执行方式 1-单次执行 2-循环执行
    executeType: 1,
  }),

  validators: {
    name: (val, allNodeData = [], currentNode = {}, getAllNodes = []) => new Promise((resolve, reject) => {
      //allNodeData是点击menu上各种操作的按钮操作之后的节点数据，getAllNodes是从画布上直接得到的所有现有节点的id，
      //当通过按钮删除节点的时候走前者，allNodeData是删除后的数据，但当不通过删除组件按钮删除节点，而是通过键盘Del键时，
      //是直接走的画布上的键盘监听方法，改变不了allNodeData，因此此处判断节点名称是否重复的时候，要计算一下
      //例如：画布上现有节点id[1,2,3]，键盘Del键删掉3之后，allNodeData仍然是[1,2,3]，而getAllNodes是[1,2]
      allNodeData.forEach((item, index) => {
        if(!getAllNodes.includes(item.nodeId)){
          allNodeData.splice(index, 1)
        }
      })
      try {
        if (val === '') {
          reject(new Error('节点名称不能为空'));
        } else if (allNodeData.filter((item) => { if (item.data.name === val && item.nodeId !== currentNode.nodeId) return item }).length >= 1) {
          reject(new Error('节点名称不能与其他节点重复'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    // executionTime: (val) => new Promise((resolve, reject) => {
    //   resolve();
    //   try {
    //     if (val === '' || val < 0) {
    //       reject(new Error('执行时间不能为空'));
    //     } else {
    //       resolve();
    //     }
    //   } catch (error) {
    //     throw error;
    //   }
    // }),
    crowdId: (val) => new Promise((resolve, reject) => {
      try {
        if (val === '') {
          reject(new Error('人群节点不能为空'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    // remark: (val) => new Promise((resolve, reject) => {
    //   try {
    //     if (val === '') {
    //       reject(new Error('备注不能为空'));
    //     } else {
    //       resolve();
    //     }
    //   } catch (error) {
    //     throw error;
    //   }
    // }),
  } ,
  components: {
    // Form: lazy(() => import('./Form')),
    // Info: lazy(() => import('./Info')),
    Form: Form,
    Info: Info,
  }
}
